import axios from "axios";

export async function addAvailabilityByDate(data: {
  description: string;
  companyId: string;
  companyLocationId: string;
  userId: string;
  availabilityTypeId: 1 | 2; //  1 = available, 2 = unavailable
  availabilityDates: {
    startDateTime: string;
    endDateTime: string;
  }[];
  allDay: boolean;
}) {
  return axios
    .post(`/AvailabilityUsers/addavailabilityuserbydate`, data)
    .then((res) => res.data);
}

export interface Availability {
  id: string;
  availabilityTypeId: 1 | 2; //  1 = available, 2 = unavailable
  description: string;
  userId: string;
  firstName: string;
  lastName: string;
  startDateTime: string;
  endDateTime: string;
}

export async function getAvailabilitiesByDate(params: {
  LocationId: string;
  startDateTime: string;
  endDateTime: string;
}) {
  return axios
    .get(`/AvailabilityUsers/getavailabilityusersdate`, {
      params,
    })
    .then((res) => res.data as Availability[])
    .catch(() => {
      return [];
    });
}

export async function deleteAvailability(id: string) {
  return axios
    .delete(`/AvailabilityUsers/deleteavailabilityuser`, {
      data: { id },
    })
    .then((res) => res.data);
}
